import { Component, inject } from '@angular/core';
import { LabBannerComponent } from '../../components/lab-banner/lab-banner.component';
import { LabBannerHostService } from './lab-banner-host.service';

@Component({
  selector: 'lab-banner-host',
  standalone: true,
  imports: [LabBannerComponent],
  template: `
    @if (host.active()) {
      <lab-banner
        [mood]="host.mood()"
        [heading]="host.heading()"
        [description]="host.description()"
        [action]="host.action()"
        [secondaryAction]="host.secondaryAction()"
        [dismissible]="host.dismissible()"
        [visible]="host.visible()"
        (visibleChange)="host.visible.set($event)"
      />
    }
  `,
})
export class LabBannerHostComponent {
  protected readonly host = inject(LabBannerHostService);
}
